import { Text } from '@chakra-ui/react';
import { selectedDatabaseIdState } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import Widget from './Widget';
import { useTerritorialActivityKPI } from '../../context/reports-api-hooks';
import { CircleIndicator } from '../indicators';
import { roundKpiValue } from '../../shared/helpers';

export default function TerritorialActivityWidget() {
  const rcaId = useRecoilValue(selectedDatabaseIdState);
  const { data: territorialActivityData, isLoading, isError } = useTerritorialActivityKPI();

  const title = 'Territorial Activity';
  const description = 'Population growth over 10 years';

  // Exclude Doc Roads
  if (rcaId === 88) {
    return null;
  }

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/territorial-activity"
      title={title}
      description={description}
      lockYear={territorialActivityData?.lockYear}
      quarter={null}
      isLoading={isLoading && !territorialActivityData}
      moreInfoContent={
        <Text fontSize="sm">The average population growth per year for the last ten years.</Text>
      }
    >
      <CircleIndicator
        size={100}
        colour={territorialActivityData?.percentage !== undefined ? 'gray.700' : null}
        value={territorialActivityData?.percentage !== undefined ? `${roundKpiValue(territorialActivityData?.percentage, 10, 1, 'max')}%` : undefined}
        isLoading={isLoading || !territorialActivityData}
      />
    </Widget>
  );
}
